import img1 from './user-images/Jigna-Mehta.png';
import img2 from './user-images/Vidhi-Mehta.png';
import img3 from './user-images/Jinali-Shah.png';
import img4 from './user-images/Bela-Shah.png';
import img5 from './user-images/Ekta-Doshi.png';
import img6 from './user-images/Sakshi-Mehta.png';
import img7 from './user-images/A-friend.png';
import img8 from './user-images/Aastha-Shah.png';

const testimonials = [
  {
    name: 'Jigna Mehta',
    img: img1,
    text: `The cute little butterfly and pop of coral beautifully highlighted amidst the turquoise sea,
    instantly attracted me to this statement neckpiece. I bought it on impulse and haven’t been disappointed.
    Repurposed with so many different outfits - I just love wearing it. This was the first of my many purchases from Diamour.
    Every time I don them, I’m showered with compliments!!!`
  },
  {
    name: 'Vidhi Mehta',
    img: img2,
    text: `My one stop shop whenever I need to spruce up an outfit, Diamour never fails to surprise me with whimsical fantasy.
    I’m totally in love with their vibrant assortment of beads that sublime in innovative designs!!`
  },
  {
    name: 'Jinali Shah',
    img: img3,
    text: `Thank you soo much for such a pretty neck piece @diamour. Just loved it !! 😍 Amazing quality and great design.
    Can't wait to buy more of such lovely jewelry!!`
  },
  {
    name: 'Bela Shah',
    img: img4,
    text: `For me - a piece of jewellery is the exclamation point that finishes any ensemble! Over the years Diamour jewellery
    has done that and more - it’s livened up my wardrobe and even boosted my confidence! Thanks for the little treasures Shivani!`
  },
  {
    name: 'Ekta Doshi',
    img: img5,
    text: `Thank you so much for the wonderful neck piece which makes me look elegant every time I wear it.
    Loved it and looking forward for many more to come. Appreciate your work and dedication for making such graceful jewelry.
    Thank you so much once again.`
  },
  {
    name: 'Sakshi Mehta',
    img: img6,
    text: `They say a smile increases your face value. But I say the neck piece is increasing my face value.
    Truly you create magic with every piece.`
  },
  {
    name: 'A friend',
    img: img7,
    text: `A nonagenarian, she fell in love with this gorgeous neckpiece from Diamour!!! 
    The 5 rows of pearls, in various shades of green reminded her of a rustic childhood, long bygone.
    She really can’t stop reminiscing about the place she once called home, every time she looks at this -
    she recounts a different tale of childhood mischief with her 4 best friends with a twinkle in her eye.`
  },
  {
    name: 'Aastha Shah',
    img: img8,
    text: `Diamour jewellery has the correct mix of glamour, intricate design and high quality, making every piece of jewellery worth a buy.
    Their statement pieces are strong and impactful, quite like the designer herself - SHIVANI DOSHI. Each & every piece that is created has a story to tell and let me tell you, I would personally love to own them all!!!
    The best part is - there's something to suit everyone's tastes and preferences!`
  },
];

export default testimonials;